module.exports = __webpack_public_path__ + "img/task_no_assignee.e7b40fa6.svg";